module.exports = __webpack_public_path__ + "img/fbafa04.jpg";